export const getIntegrations = () => ({
    type: 'GET_INTEGRATIONS'
});

export const setIntegrations = (data) => ({
    type: 'SET_INTEGRATIONS',
    payload: data
});

export const createIntegration = (data) => ({
    type: 'CREATE_INTEGRATION',
    payload: data
});

export const deleteIntegration = (id) => ({
    type: 'DELETE_INTEGRATION',
    payload: id
});

export const disconnectGmail = () => ({
    type: 'DISCONNECT_GMAIL'
});

// Generic OAuth Callback Actions (by provider)
export const handleOAuthCallback = (provider, code, state) => ({
    type: 'HANDLE_OAUTH_CALLBACK',
    payload: { provider, code, state }
});

export const setOAuthCallbackSuccess = (provider, email, metadata = null) => ({
    type: 'SET_OAUTH_CALLBACK_SUCCESS',
    payload: { provider, email, metadata }
});

export const setOAuthCallbackError = (provider, error) => ({
    type: 'SET_OAUTH_CALLBACK_ERROR',
    payload: { provider, error }
});

export const setGmailCallbackError = (error) => ({
    type: 'SET_OAUTH_CALLBACK_ERROR',
    payload: { provider: 'gmail', error }
});

// Dynamic Integration Status Actions (by toolName or array of toolNames)
export const getIntegrationStatus = (toolName) => ({
    type: 'GET_INTEGRATION_STATUS',
    payload: { toolName: Array.isArray(toolName) ? toolName.join(',') : toolName }
});

export const setIntegrationStatus = (toolName, status) => ({
    type: 'SET_INTEGRATION_STATUS',
    payload: { toolName, status }
});

export const setIntegrationStatusError = (toolName, error) => ({
    type: 'SET_INTEGRATION_STATUS_ERROR',
    payload: { toolName, error }
});

// Integration Service Actions
export const getIntegrationTools = () => ({
    type: 'GET_INTEGRATION_TOOLS'
});

export const setIntegrationTools = (tools) => ({
    type: 'SET_INTEGRATION_TOOLS',
    payload: tools
});

// Dynamic Token Refresh Action (by toolName)
export const refreshIntegrationToken = (toolName) => ({
    type: 'REFRESH_INTEGRATION_TOKEN',
    payload: { toolName }
});

// Dynamic Test Connection Action (by integrationId)
export const testIntegrationConnection = (payload) => ({
    type: 'TEST_INTEGRATION_CONNECTION',
    payload
});

// Node Tools Actions
export const getNodeTools = () => ({
    type: 'GET_NODE_TOOLS'
});

export const setNodeToolsSuccess = (nodeTools) => ({
    type: 'SET_NODE_TOOLS_SUCCESS',
    payload: nodeTools
});

export const setNodeToolsError = (error) => ({
    type: 'SET_NODE_TOOLS_ERROR',
    payload: error
});

export const getNodeDefinition = (nodeType) => ({
    type: 'GET_NODE_DEFINITION',
    payload: { nodeType }
});

// Available Integrations Actions (for dropdowns)
export const getAvailableIntegrations = (toolName) => ({
    type: 'GET_AVAILABLE_INTEGRATIONS',
    payload: { toolName }
});

export const setAvailableIntegrations = (data) => ({
    type: 'SET_AVAILABLE_INTEGRATIONS',
    payload: data
});

export const setAvailableIntegrationsError = (error) => ({
    type: 'SET_AVAILABLE_INTEGRATIONS_ERROR',
    payload: error
});

export const clearAvailableIntegrations = () => ({
    type: 'CLEAR_AVAILABLE_INTEGRATIONS'
});

// Update integration visibility
export const updateIntegrationVisibility = (integrationId, visibilityType) => ({
    type: 'UPDATE_INTEGRATION_VISIBILITY',
    payload: { integrationId, visibilityType }
});

// Set primary integration account
export const setPrimaryIntegration = (integrationId) => ({
    type: 'SET_PRIMARY_INTEGRATION',
    payload: { integrationId }
});

// Create integration state actions
export const resetCreateIntegration = () => ({
    type: 'CREATE_INTEGRATION_RESET'
});

// ============================================================================
// SALES ACCOUNT ACTIONS
// ============================================================================

// Get all sales accounts
export const getSalesAccounts = () => ({
    type: 'GET_SALES_ACCOUNTS'
});

export const setSalesAccounts = (data) => ({
    type: 'SET_SALES_ACCOUNTS',
    payload: data
});

export const setSalesAccountsError = (error) => ({
    type: 'SET_SALES_ACCOUNTS_ERROR',
    payload: error
});

// Create sales account
export const createSalesAccount = (data) => ({
    type: 'CREATE_SALES_ACCOUNT',
    payload: data
});

export const createSalesAccountSuccess = (account) => ({
    type: 'CREATE_SALES_ACCOUNT_SUCCESS',
    payload: account
});

export const createSalesAccountError = (error) => ({
    type: 'CREATE_SALES_ACCOUNT_ERROR',
    payload: error
});

export const resetCreateSalesAccount = () => ({
    type: 'CREATE_SALES_ACCOUNT_RESET'
});

// ============================================================================
// LINKEDIN ACCOUNT ACTIONS
// ============================================================================

export const createLinkedInAccount = (data, onSuccess, onFailure) => ({
    type: 'CREATE_LINKEDIN_ACCOUNT',
    payload: { ...data, onSuccess, onFailure }
});

export const initiateLinkedInLogin = (id, data, onSuccess, onFailure) => ({
    type: 'INITIATE_LINKEDIN_LOGIN',
    payload: { id, ...data, onSuccess, onFailure }
});

export const verifyLinkedInCode = (id, code, onSuccess, onFailure) => ({
    type: 'VERIFY_LINKEDIN_CODE',
    payload: { id, code, onSuccess, onFailure }
});

export const setLinkedInLoginState = (id, loginState) => ({
    type: 'SET_LINKEDIN_LOGIN_STATE',
    payload: { id, loginState }
});

export const cancelLinkedInVerification = (id, onSuccess, onFailure) => ({
    type: 'CANCEL_LINKEDIN_VERIFICATION',
    payload: { id, onSuccess, onFailure }
});

export const resendLinkedInCode = (id, onSuccess, onFailure) => ({
    type: 'RESEND_LINKEDIN_CODE',
    payload: { id, onSuccess, onFailure }
});

export const enrichLinkedInContact = (data, onSuccess, onFailure) => ({
    type: 'ENRICH_LINKEDIN_CONTACT',
    payload: { ...data, onSuccess, onFailure }
});

// Update sales account
export const updateSalesAccount = (id, data) => ({
    type: 'UPDATE_SALES_ACCOUNT',
    payload: { id, data }
});

export const updateSalesAccountSuccess = (account) => ({
    type: 'UPDATE_SALES_ACCOUNT_SUCCESS',
    payload: account
});

export const updateSalesAccountError = (error) => ({
    type: 'UPDATE_SALES_ACCOUNT_ERROR',
    payload: error
});

// Delete sales account
export const deleteSalesAccount = (id) => ({
    type: 'DELETE_SALES_ACCOUNT',
    payload: id
});

export const deleteSalesAccountSuccess = (id) => ({
    type: 'DELETE_SALES_ACCOUNT_SUCCESS',
    payload: id
});

export const deleteSalesAccountError = (error) => ({
    type: 'DELETE_SALES_ACCOUNT_ERROR',
    payload: error
});

// Set primary sales account
export const setPrimarySalesAccount = (id) => ({
    type: 'SET_PRIMARY_SALES_ACCOUNT',
    payload: id
});

// Link integration to sales account
export const linkIntegrationToSalesAccount = (salesAccountId, integrationId) => ({
    type: 'LINK_INTEGRATION_TO_SALES_ACCOUNT',
    payload: { salesAccountId, integrationId }
});

// Unlink integration from sales account
export const unlinkIntegrationFromSalesAccount = (integrationId) => ({
    type: 'UNLINK_INTEGRATION_FROM_SALES_ACCOUNT',
    payload: { integrationId }
});

// ============================================================================
// EMAIL SETTINGS ACTIONS (Warmup, Campaign Settings)
// ============================================================================

export const getEmailSettings = (integrationId) => ({
    type: 'GET_EMAIL_SETTINGS',
    payload: { integrationId }
});

export const setEmailSettings = (integrationId, settings) => ({
    type: 'SET_EMAIL_SETTINGS',
    payload: { integrationId, settings }
});

export const connectSmtpAccount = (data, onSuccess, onFailure) => ({
    type: 'CONNECT_SMTP_ACCOUNT',
    payload: { ...data, onSuccess, onFailure }
});

export const testSmtpConnection = (id, onSuccess, onFailure) => ({
    type: 'TEST_SMTP_CONNECTION',
    payload: { id, onSuccess, onFailure }
});

export const getDomainHealth = (integrationId, callback) => ({
    type: 'GET_DOMAIN_HEALTH',
    payload: integrationId,
    callback
});

export const getDomainHealthBatch = (ids, callback) => ({
    type: 'GET_DOMAIN_HEALTH_BATCH',
    payload: ids,
    callback
});

export const getCampaignStatsBatch = (ids, callback) => ({
    type: 'GET_CAMPAIGN_STATS_BATCH',
    payload: ids,
    callback
});

export const getEmailSettingsBatch = (ids) => ({
    type: 'GET_EMAIL_SETTINGS_BATCH',
    payload: ids
});

export const runPlacementTest = (integrationId, callback) => ({
    type: 'RUN_PLACEMENT_TEST',
    payload: integrationId,
    callback
});